import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Reveal } from "@/components/site/Reveal";

export default function ContentPage({ slug, badge }) {
  const [page, setPage] = useState({ title: "", body: "" });

  useEffect(() => {
    api.get(`/pages/${slug}`).then(({ data }) => setPage(data)).catch(() => {});
  }, [slug]);

  return (
    <>
      <section className="bg-[#0A1A10] sr-grain pt-36 pb-16">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <span className="font-mono-accent text-xs uppercase tracking-widest text-[#D4AF37]">{badge}</span>
          <h1 className="font-serif-display text-white text-4xl sm:text-5xl font-bold mt-3 leading-tight">{page.title}</h1>
        </div>
      </section>
      <section className="bg-[#F8F9FA] py-16 sm:py-20 min-h-[40vh]">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Reveal>
            <div className="rich-content bg-white rounded-3xl border border-[#E2E8E4] p-8 sm:p-12" data-testid={`${slug}-content`} dangerouslySetInnerHTML={{ __html: page.body || "" }} />
          </Reveal>
        </div>
      </section>
    </>
  );
}
